import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

/**
 * Subscription Cancel Page
 * 
 * Displayed when user cancels Stripe checkout.
 */
export default function SubscriptionCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] flex items-center justify-center p-4">
      <motion.div
        className="max-w-md w-full bg-[var(--bg-card)] rounded-2xl border border-[var(--border-color)] p-8 text-center"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
      >
        <div className="w-20 h-20 rounded-full bg-orange-500/20 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-orange-400" />
        </div>
        
        <h1 className="text-2xl font-bold text-white mb-2">Checkout Cancelled</h1>
        <p className="text-[var(--text-secondary)] mb-6">
          No worries! You can upgrade anytime when you're ready.
        </p>
        
        <div className="space-y-3">
          <button
            onClick={() => navigate('/subscription')}
            className="w-full py-3 px-4 rounded-xl bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-secondary)] text-white font-semibold flex items-center justify-center gap-2 hover:opacity-90 transition-all"
          >
            View Plans Again
          </button>
          
          <button
            onClick={() => navigate('/chat')}
            className="w-full py-3 px-4 rounded-xl bg-[var(--bg-tertiary)] text-white font-semibold flex items-center justify-center gap-2 hover:bg-[var(--bg-hover)] transition-all"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to AIRA
          </button>
        </div>
      </motion.div>
    </div>
  );
}
